import { MixResponseDTO } from '@/core/api/dtos/response/radio/mix'
import { Mix } from '@/core/api/entities/radio/mix'
import { MixRadio } from '@/core/api/entities/radio/mixRadio'

import { RadioMapper } from './radioMapper'

export class MixMapper {
	static toEntity(data: MixResponseDTO): Mix {
		return Mix.create({
			id: data.id,
			title: data.title,
			mixRadios: data.radios?.data.map((radio) =>
				MixRadio.create({
					id: radio.metadata?.mix?.id,
					mixId: radio.metadata?.mix?.mix_id,
					radioId: radio.id,
					mixPercentage: radio.metadata?.mix?.mix_percentage,
					rrule: radio.metadata?.mix?.rrule,
					isDefault: radio.metadata?.mix?.is_default,
					radio: RadioMapper.toEntity(radio),
				})
			),
		})
	}

	static toEntities(data: MixResponseDTO[]): Mix[] {
		return data.map((mix) => MixMapper.toEntity(mix))
	}
}
